/* eslint-disable react/require-default-props, react/prop-types */
import * as React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { useInput, FieldTitle } from 'ra-core';
import { sanitizeInputRestProps, InputHelperText } from 'react-admin';

const validateValue = value => {
  const rgx = /^[-+]?[0-9]*\.?[0-9]+$/;
  return Boolean(value?.toString()?.match(rgx));
};

const NumberInput = ({
  format,
  helperText,
  label,
  margin = 'dense',
  onBlur,
  onFocus,
  onChange,
  options,
  parse,
  resource,
  source,
  step,
  min,
  max,
  validate,
  variant = 'outlined',
  inputProps: overrideInputProps,
  ...rest
}) => {
  const {
    id,
    input,
    isRequired,
    meta: {
      error, submitError, touched,
    },
  } = useInput({
    format,
    onBlur,
    onChange,
    onFocus,
    parse,
    resource,
    source,
    validate,
    ...rest,
  });

  const inputProps = {
    ...overrideInputProps,
    step,
    min,
    max,
  };

  const handleChange = e => {
    const { value } = e.target;
    if (value === '-' || !value?.length) input.onChange(value);
    const floatNumber = parseFloat(value);
    if (validateValue(value) && floatNumber <= Number.MAX_SAFE_INTEGER && floatNumber >= Number.MIN_SAFE_INTEGER) input.onChange(floatNumber);
  };

  return (
    <TextField
      id={id}
      {...input}
      onChange={handleChange}
      variant={variant}
      error={!!(touched && (error || submitError))}
      helperText={(
        <InputHelperText
          touched={touched}
          error={error || submitError}
          helperText={helperText}
        />
      )}
      label={(
        <FieldTitle
          label={label}
          source={source}
          resource={resource}
          isRequired={isRequired}
        />
      )}
      margin={margin}
      inputProps={inputProps}
      {...options}
      {...sanitizeInputRestProps(rest)}
    />
  );
};

NumberInput.propTypes = {
  label: PropTypes.string,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

NumberInput.defaultProps = {
  options: {},
  step: 'any',
  // textAlign: 'right',
  label: '',
};

export default NumberInput;
